import React from 'react';
import {Paper, Table, TableBody, TableRow, TableRowColumn} from 'material-ui';
import {observer, inject} from 'mobx-react';
import {cmURL} from '../libs/config'

@inject('contentStore')
@observer
class CurrentForecast extends React.Component {

    render() {
      let {current_forecast} = this.props.contentStore;
      return(
        <div className="inline-it">
          <Paper zDepth={2}>
            <Table style={{maxWidth:'1000px'}}>
              <TableBody displayRowCheckbox={false} showRowHover={false} stripedRows={true}>{
                current_forecast.length>0 && current_forecast.map((item, index) => (
                  <TableRow selectable={false} key={index}>
                    <TableRowColumn style={{whiteSpace:'normal'}}>
                      <a href={`${cmURL}/files/${item.file_name}`} target="_blank" rel="noopener noreferrer" className="content-title">{item.title}</a>
                    </TableRowColumn>
                  </TableRow>
                ))
              }</TableBody>
            </Table>
          </Paper>
        </div>
      );
    }
}

export default CurrentForecast;


// WEBPACK FOOTER //
// ./src/components/CurrentForecast.js